<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{ locale.guest_count_settings }}</h2>
      <div class="innerContent">
        <!-- 활성화 -->
        <div class="innerTitle">
          <div class="checkbox">
            <input type="checkbox" id="guest_count_activate" v-model="isActive">
            <label for="guest_count_activate">{{ locale.activate }}</label>
          </div>
        </div>
        <!-- //활성화 -->
        <!-- 인원 선택 화면 타이틀 -->
        <div class="mt15 mb15">
          <div class="setLabel mb10">{{ locale.title }}</div>
          <SetLanguageValue
            :locale="locale"
            :langValue="title"
            class="countTitle" />
        </div>
        <!-- //인원 선택 화면 타이틀 -->
        <!-- 인원그룹 설정 -->
        <div class="mb15">
          <div class="setLabel">
            {{ locale.guest_group }}
            <button
              type="button"
              class="btn btnWhite sizeS"
              @click="setGuestGroup(catCode)">
              {{ locale.guest_group_management }}
            </button>
          </div>
          <div class="mt15 mb5">
            <p class="sysMessage">{{ locale.message_create_guest_group }}</p>
          </div>
          <div class="guestGroupList">
            <div
              v-for="(item, index) in guestGroup"
              :key="index"
              :class="{isInvalid: !isValid(item).result}"
              class="guestGroupItem">
              <button class="btnDel" @click.stop="delItem(item.groupId)"></button>
              <div class="mb10">
                <div class="innerTitle setLabel">{{ locale.select_group }}</div>
                <select class="input select" v-model="item.groupId">
                  <option v-if="!item.groupId" value="">{{ locale.message_setup_guest_group }}</option>
                  <option
                    v-for="guestTypeItem in guestTypeItems"
                    :key="guestTypeItem.groupId"
                    :value="guestTypeItem.groupId">
                    {{ guestTypeItem.groupName[defaultLang] }}
                  </option>
                </select>
                <p v-if="item.groupId" class="groupId">{{ item.groupId }}</p>
              </div>
              <div class="mb10">
                <div class="innerTitle setLabel">{{ locale.guest_settings }}</div>
                <div class="flexContainer">
                  <div class="flexItem">
                    <div class="colorGrey">{{ locale.default }}</div>
                    <input type="text" class="input" @input="inputNumber(index, 'initNum')" v-model="item.settings.initNum">
                  </div>
                  <div class="flexItem">
                    <div class="colorGrey">{{ locale.min }}</div>
                    <input type="text" class="input" @input="inputNumber(index, 'minNum')" v-model="item.settings.minNum">
                  </div>
                  <div class="flexItem">
                    <div class="colorGrey">{{ locale.max }}</div>
                    <input type="text" class="input" @input="inputNumber(index, 'maxNum')" v-model="item.settings.maxNum">
                  </div>
                </div>
              </div>
              <div class="mb10">
                <div class="innerTitle setLabel">
                  {{ locale.link_item }}
                  <button type="button" class="btn btnWhite sizeXs" @click.stop="detailGroup = item.groupId">{{ locale.search }}</button>
                </div>
                <select class="input select" v-model="item.shopItemId">
                  <option value="">{{ locale.not_setting }}</option>
                  <option
                    v-for="shopItem in shopItems"
                    :key="shopItem.shopItemId"
                    :value="shopItem.shopItemId">
                    {{ `${shopItem.pId ? '[' + shopItem.pId + '] ' : ''}${shopItem.shopItemName}` }}
                  </option>
                </select>
              </div>
              <div v-if="isValid(item).messages.length > 0">
                <p v-for="(msg, index) in isValid(item).messages"
                  :key="index" class="infoMessage colorRed">
                  {{ msg }}
                </p>
              </div>
            </div>
            <button v-if="guestGroup.length <= 2" class="guestGroupItem btnAdd" @click.stop="addItem"></button>
          </div>
        </div>
        <!-- //인원그룹 설정 -->
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" :disabled="isDisabled" @click="save">{{ locale.save }}</button>
      </div>
    </div>
    <ItemListAll v-if="detailGroup"
      :locale="locale"
      @close="detailGroup = null"
      @apply="applyItem" />
    <CompositeGuestGroup v-if="setGuestTypeItems"
      :locale="locale"
      :catCode="catCode"
      @close="setGuestGroup" />
  </div>
</template>

<script>
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import SetLanguageValue from '@/components/Util/SetLanguageValue'
import ItemListAll from './ItemListAll'
import CompositeGuestGroup from './CompositeGuestGroup'

export default {
  name: 'GuestCount',
  props: [
    'locale',
    'defaultLang',
    'pageId',
    'catCode'
  ],
  components: {
    SetLanguageValue,
    ItemListAll,
    CompositeGuestGroup
  },
  computed: {
    isDisabled () {
      const groups = this.guestGroup
      return this.isActive && (groups.length <= 0 || groups.find(item => !this.isValid(item).result))
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      isActive: false,
      title: LANG.valueObj(''),
      defaultGuestItem: {
        groupId: '',
        groupName: LANG.valueObj(''),
        settings: {
          initNum: 2,
          minNum: 0,
          maxNum: 99,
        },
        shopItemId: ''
      },
      guestGroup: [],
      shopItems: [],
      detailGroup: null,
      guestTypeItems: [],
      setGuestTypeItems: false
    }
  },
  methods: {
    async init () {
      this.$store.commit('onLoading', true)
      this.getGuestTypeItems() // 비동기로 guestTypeItems 호출
      await this.getShopGuestSettings()
      await this.getAllShopItems()
      this.$store.commit('onLoading', false)
    },
    async getAllShopItems () {
      const getShopItems = await this.$store.dispatch('shop/getAllShopItems', this.pageId)
      const items = getShopItems?.message?.shopItems
      const defaultLang = this.defaultLang
      if (items && items.length > 0) {
        this.shopItems = items.filter(item => !item.isOptItem).map(x => {
          return {
            shopItemId: x.shopItemId,
            shopItemName: `${x.shopItemName[defaultLang]}`,
            ...x.pId && {
              pId: x.pId
            }
          }
        })
      }
      return items
    },
    async getShopGuestSettings () {
      const getGuestSettings = await this.$store.dispatch('shop/getShopGuestSettings', this.pageId)
      const guestSettings = getGuestSettings && getGuestSettings.message
      if (guestSettings) {
        this.isActive = guestSettings.active
        this.guestGroup = guestSettings.settingItems?.map(group => {
          return {
            ...group,
            groupName: {
              ...LANG.valueObj(''),
              ...group.groupName
            },
            shopItemId: group.shopItemId || ''
          }
        })
        this.title = {
          ...this.title,
          ...guestSettings.title
        }
      }
    },
    async getGuestTypeItems () {
      const guestTypeItems = await this.$store.dispatch('shop/getGuestTypeItems', this.catCode)
      const items = guestTypeItems?.message
      this.guestTypeItems = items
    },
    setGuestGroup () {
      if (this.setGuestTypeItems) {
        alert(this.locale.message_save_after_change)
      }
      this.setGuestTypeItems = !this.setGuestTypeItems
      if (!this.setGuestTypeItems) {
        this.getGuestTypeItems()
      }
    },
    isValid (groupItem) {
      if (!groupItem?.groupId) {
        return { result: false, messages: [this.locale.message_setup_guest_group] }
      }

      const settings = groupItem?.settings

      function validateRange({ maxNum, initNum, minNum, locale }) {
        const messages = [];

        // ────────────── 숫자 체크 ──────────────
        const nums = { maxNum, initNum, minNum };
        Object.entries(nums).forEach(([key, value]) => {
          if (typeof value !== 'number' || Number.isNaN(value)) {
            messages.push(locale.message_enter_a_number)
          } else if (value < 0) {
            messages.push(`${locale.message_enter_a_number_lt_0}(${key})`)
          }
        });

        // 숫자 검사에서 이미 실패가 났으면 이후 비교 조합은 검증할 필요 없음
        if (messages.length === 0) {
          // ────────────── 범위 검증 ──────────────
          if (initNum < minNum) {
            // 기본값이 최소값({{minNum}})보다 작습니다.
            messages.push(locale.message_default_is_lt_min.replace('{{minNum}}', minNum))
          }
          if (initNum > maxNum) {
            // 기본값이 최대값({{maxNum}})보다 큽니다.
            messages.push(locale.message_default_is_exceed_max.replace('{{maxNum}}', maxNum))
          }
          if (minNum > maxNum) {
            // 최소값이 최대값({{maxNum}})보다 큽니다.
            messages.push(locale.message_min_is_exceed_max.replace('{{maxNum}}', maxNum))
          }
          if (maxNum < 1) {
            // 최대값({{maxNum}})을 1이상 입력해주세요.
            messages.push(locale.message_enter_max_gt_1.replace('{{maxNum}}', maxNum))
          }
        }

        return {
          result: messages.length === 0,
          messages
        };
      }

      if (!settings) {
        return { result: false, messages: ['not found settings'] };
      }

      return validateRange({...settings, locale: this.locale});
    },
    inputNumber (index, key) {
      const item = this.guestGroup[index]
      const value = Number(regExp.numberOnly(item.settings[key]))
      item.settings[key] = value
    },
    addItem () {
      const item = this._.cloneDeep(this.defaultGuestItem)
      this.guestGroup.push(item)
    },
    delItem (groupId) {
      this.guestGroup = this.guestGroup.filter(x => x.groupId !== groupId)
    },
    applyItem (item) {
      const groupId = this.detailGroup
      this.guestGroup = this.guestGroup.map(group => {
        const isGroup = group.groupId === groupId
        return {
          ...group,
          ...isGroup && {
            shopItemId: item.shopItemId
          }
        }
      })
    },
    close () {
      this.$emit('close')
    },
    async save () {
      const filteredLanguageValues = this.$store.getters['util/filteredLanguageValues']
      const getGroupNameById = groupId => this.guestTypeItems?.find(item => item.groupId === groupId)?.groupName
      const data = {
        pageId: this.pageId,
        active: this.isActive,
        title: this.title,
        settingItems: transformCategoryLabels(this.guestGroup, filteredLanguageValues)
      }
      // 사용하는 언어만 남기고 삭제하여 전체 그룹 리스트를 리턴
      function transformCategoryLabels (data, filterFunc) {
        return data.map(item => {
          const groupName = getGroupNameById(item.groupId)
          const transformedItem = {
            ...item,
            groupName: filterFunc(groupName),
            shopItemId: item.shopItemId || null
          }
          return transformedItem
        })
      }

      if (window.confirm(this.locale.confirm_save)) {
        this.$store.commit('onLoading', true)
        const res = await this.$store.dispatch('shop/putShopGuestSettings', data)
        if (res?.status === 200) {
          alert(this.locale.complete_save)
          this.$emit('close')
        }
        this.$store.commit('onLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 800px;
  }
}
.countTitle {
  max-width: 320px;
}
.guestGroupList {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 12px;
  align-items: flex-start;
}
.guestGroupItem {
  position: relative;
  padding: 24px 12px;
  border: 1px solid $color-lgrey2;
  border-radius: 8px;
  background-color: $color-white;
  &.isInvalid {
    border-color: $color-red;
  }
  .groupId {
    color: $color-lgrey;
    font-size: 10px;
  }
  .btnDel {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    background: url('~@/assets/img/ico_close_black.svg') 50% 50% / 16px no-repeat;
    opacity: 0.3;
  }
  &.btnAdd {
    min-height: 160px;
    border-width: 2px;
    border-style: dashed;
    background-color: #fff;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 40px;
      height: 4px;
      margin-top: -2px;
      margin-left: -20px;
      background-color: $color-lgrey2;
    }
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 4px;
      height: 40px;
      margin-top: -20px;
      margin-left: -2px;
      background-color: $color-lgrey2;
    }
  }
}
.flexContainer {
  column-gap: 8px;
}
</style>
